import { render, staticRenderFns } from "./ProductDelete.vue?vue&type=template&id=5c98efa0&"
import script from "./ProductDelete.vue?vue&type=script&lang=js&"
export * from "./ProductDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports